import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ActivatedRoute, Router } from '@angular/router'

import { debounceTime, distinctUntilChanged, filter, tap, withLatestFrom } from 'rxjs'

import { CompanyFacade } from '~/core/features'
import { LoadingComponent } from '~/ui/loading'

@Component({
  selector: 'app-edgar-report',
  templateUrl: './edgar-report.component.html',
  styleUrl: './edgar-report.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, LoadingComponent],
})
export class EdgarReportComponent implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute)
  private readonly destroyRed = inject(DestroyRef)
  private readonly router = inject(Router)

  readonly companyFacade = inject(CompanyFacade)

  constructor() {}

  ngOnInit(): void {
    // TODO: refactor
    this.companyFacade.ticker$
      .pipe(
        filter(ticker => Boolean(ticker)),
        distinctUntilChanged(),
        debounceTime(100), // INFO: To avoid infinite redirect loop
        withLatestFrom(this.companyFacade.forecast$),
        tap(([, forecast]) => {
          if (!forecast?.summary) {
            this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent })
          }
        }),
        takeUntilDestroyed(this.destroyRed)
      )
      .subscribe()
  }
}
